module.exports = __webpack_public_path__ + "static/img/loginbg1.288b6e81.jpg";